import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth, isStaffUser } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");

    const process = async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        const user = res.data.user;
        setUser(user);
        const pendingIntake = localStorage.getItem("pending_intake");
        if (pendingIntake) {
          try {
            await api.post(`/intakes/${pendingIntake}/claim`);
            localStorage.removeItem("pending_intake");
          } catch {
            // intake claim can be retried from portal
          }
        }
        window.history.replaceState(null, "", window.location.pathname);
        navigate(isStaffUser(user) ? "/staff" : "/portal", { replace: true, state: { user } });
      } catch {
        navigate("/login", { replace: true });
      }
    };
    process();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-ivory gap-4" data-testid="auth-callback">
      <div className="h-10 w-10 rounded-full border-2 border-teal border-t-transparent animate-spin" />
      <p className="text-sm text-mutedink">Signing you in securely...</p>
    </div>
  );
}
